import { h, render, watch } from 'vue'
import UploadMask from './components/uploadMask.vue'

// 创建浮窗
const createMask = (el, binding) => {
  el.style.position = 'relative'
  const container = document.createElement('div')
  const vNode = h(UploadMask, binding)
  render(vNode, container)
  const uploadEle = container.firstElementChild

  // 将浮窗元素存储到el的自定义属性中
  el._uploadMaskEle = uploadEle
  el.appendChild(uploadEle)

  return uploadEle
}

// 更新浮窗
const updateMask = (el, binding) => {
  if (el._uploadMaskEle) {
    // 重新渲染组件，传递新的 props
    const container = document.createElement('div')
    const vNode = h(UploadMask, binding)
    render(vNode, container)
    const newUploadEle = container.firstElementChild

    // 替换旧的元素
    el.replaceChild(newUploadEle, el._uploadMaskEle)
    el._uploadMaskEle = newUploadEle
  }
}

// 关闭浮窗
const closeMask = (el) => {
  if (el._uploadMaskEle) {
    el._uploadMaskEle.style.display = 'none'
  }
}

// 开启浮窗
const openMask = (el) => {
  if (el._uploadMaskEle) {
    el._uploadMaskEle.style.display = 'block'
  }
}

// 拖拽进入目标区域
const handleDragEnter = (e) => {
  e.preventDefault() // 阻止默认行为
  e.stopPropagation() // 阻止事件冒泡（避免影响父元素）
  openMask(e.currentTarget)
}

// 拖拽在目标区域内移动
const handleDragOver = (e) => {
  e.preventDefault()
  e.stopPropagation()
  // 设置拖放效果
  e.dataTransfer.dropEffect = 'copy'
}

// 拖拽离开目标区域
const handleDragLeave = (e) => {
  e.preventDefault()
  e.stopPropagation()
  // 注意：需要判断是否真的离开整个区域（避免子元素触发误判）
  const relatedTarget = e.relatedTarget
  if (!e.currentTarget.contains(relatedTarget)) {
    closeMask(e.currentTarget)
  }
}

// 放下文件
const handleDrop = (e) => {
  e.preventDefault()
  e.stopPropagation()
  closeMask(e.currentTarget)
}

export default function (app) {
  app.directive('dropUpload', {
    mounted(el, binding) {
      // 创建浮窗
      createMask(el, binding.value)

      // 绑定事件监听器
      el.addEventListener('dragenter', handleDragEnter)
      el.addEventListener('dragover', handleDragOver)
      el.addEventListener('dragleave', handleDragLeave)
      el.addEventListener('drop', handleDrop)

      // 监听 binding 值的变化
      const unwatch = watch(
        () => binding.value,
        (newVal) => {
          updateMask(el, newVal)
        },
        { deep: true } // 深度监听，确保嵌套对象的变化也能被检测到
      )
      // 将取消监听函数存储到元素上，以便在 unmounted 时清理
      el._dropUploadUnwatch = unwatch
    },
    updated(el, binding) {
      // 当指令的值更新时，也更新浮窗
      updateMask(el, binding.value)
    },
    unmounted(el) {
      // 清理监听器
      if (el._dropUploadUnwatch) {
        el._dropUploadUnwatch()
        el._dropUploadUnwatch = null
      }

      // 移除事件监听器
      el.removeEventListener('dragenter', handleDragEnter)
      el.removeEventListener('dragover', handleDragOver)
      el.removeEventListener('dragleave', handleDragLeave)
      el.removeEventListener('drop', handleDrop)

      // 清理DOM元素
      if (el._uploadMaskEle && el.contains(el._uploadMaskEle)) {
        el.removeChild(el._uploadMaskEle)
        el._uploadMaskEle = null
      }
    }
  })
}
